/**
 * ⚠️ TEMPORARY: React.StrictMode DISABLED for performance testing
 * - StrictMode causes double-rendering and double API calls in development
 * - To re-enable: wrap the app with <React.StrictMode> tags
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './routes';
import { CompanyProvider } from './contexts/CompanyContext';
import { SessionProvider } from './contexts/SessionContext';
import { ReloginModal } from './components/ReloginModal';
import './index.css'; // Import Tailwind CSS and global styles



ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode> {/* TEMPORARY: Disabled for performance testing */}
  <BrowserRouter>
    <AuthProvider>
      <CompanyProvider>
        <SessionProvider>
          <AppRoutes/>
          {/* App-wide session-expiry recovery dialog (opened via reloginModalBus).
              Mounted at the root — outside any page form — so its events never
              interfere with page-level listeners (e.g. EditFilings validation). */}
          <ReloginModal />
        </SessionProvider>
      </CompanyProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);